module.exports = __webpack_public_path__ + "media/images/fold-d12a66d53fce66391b3ce85a88180f63.svg";